import SnapDialog from './src/main';
require('library-@/assets/styles/ui-default-theme/dialog.scss');

/* istanbul ignore next */
SnapDialog.install = function(Vue) {
    Vue.component(SnapDialog.name, SnapDialog);
};

export default SnapDialog;
